import { SxProps, Theme } from "@mui/material/styles"

export interface IAuthResponse {
    username: string,
    role: string,
    fullname: string,
    token: string,
    isLoggedIn: boolean
}


export interface IUserLocationPermission {
    permissionLevel?: string,
    userId: string,
    wnummer?: string,
}
export interface ILocation {
    id? : string,
    wnummer?: string,
    name: string,
    capacity: number,
    locationCategory: string,
    district: string,
    residentGroups: string,
    address: string,
    applicationUserId: string[],
    userLocationPermissions: IUserLocationPermission[],
    contactPerson?: string,
    phoneNumber?: string,
    email?: string,
    startOfOccupancy?: Date,
    endOfOccupancy?: Date,
    businessDivision?: string,
    bl?: string,
    tl?: string,
    lastUpdate?: Date,
}

export const emptyLocation: ILocation = {
    id: '',
    name: '',
    capacity: 0,
    locationCategory: '',
    district: '',
    residentGroups: '',
    address: '',
    email: '',
    applicationUserId: [],
    userLocationPermissions: [],
    bl: '',
    businessDivision: '',
    contactPerson: '',
    wnummer: '',
    startOfOccupancy: new Date(Date.now()),
    endOfOccupancy: new Date(Date.now())
}

export const Bezirke: string[] = [ 'Altona', 'Bergedorf','Eimsbüttel','Harburg','Mitte','Nord','Wandsbek' ]
export const Kategorien: string[] = [    'Interim Hotel', 'Interim örU', 'Notstandort']

export interface IFreeSpaceBasic  {
    wnummer?: string,
    roomspaceId?: string,
    numberOfOccupiedUkr: number,
    numberOfOccupiedOru: number,
    numberOfAvailablePlaces: number,
    numberOfReservedSeats: number,
    numberOfUnoccupiedSeats :number,
    whyNotAssignable: string,
    roomcapacity?: number
};

export interface IFreeRoom extends IFreeSpaceBasic {
    //singleRoomW: number,
    //text_SingleRoomW?: string;
    //singleRoomM: number,
    //text_SingleRoomM?: string;
    singleRoomFMD: number,
    text_SingleRoomFMD?: string;
    feedSlotW: number,
    text_FeedSlotW?: string;
    feedSlotM: number,
    text_FeedSlotM?: string;
    roomForTwo: number,
    text_RoomForTwo?: string,
    roomForThree: number,
    text_RoomForThree?: string;
    roomForFour: number,
    text_RoomForFour?: string;
    roomForFive: number,
    text_RoomForFive?: string;
    roomForSix: number,
    text_RoomForSix?: string;
    roomForSeven: number,
    text_RoomForSeven?: string;
    roomForEight: number,
    text_RoomForEight?: string;
    roomForNine: number,
    text_RoomForNine?: string;
    roomForTen: number,
    text_RoomForTen?: string;
    totalSeats: number,
    lastUpdate?: Date,
    seatsQuantityChanged?: number,
    allRoomsComments?: string,
    lastEditBy?: string;
    notesOnAccommodation? : string;
}
export const emptyRoom:IFreeRoom = {
    wnummer: '',
    //singleRoomW: 0,
    //singleRoomM: 0,
    singleRoomFMD: 0,
    feedSlotW: 0,
    feedSlotM: 0,
    roomForTwo: 0,
    roomForThree: 0,
    roomForFour: 0,
    roomForFive: 0,
    roomForSix: 0,
    roomForSeven: 0,
    roomForEight: 0,
    roomForNine: 0,
    roomForTen: 0,
    totalSeats: 0,
    numberOfOccupiedUkr: 0,
    numberOfOccupiedOru: 0,
    numberOfAvailablePlaces: 0,
    numberOfReservedSeats: 0,
    numberOfUnoccupiedSeats: 0,
    whyNotAssignable: '',
    seatsQuantityChanged: 0,
    lastEditBy: ''
}


export const sxfw:SxProps<Theme> = { m: 1, p: 1 }
export const sxfwNarrow:SxProps<Theme> = { m: 0.5, p: 0.5 }
export const sxlogin:SxProps<Theme> = { my: 0.2, py: 0.2 }
export const sxHistory:SxProps<Theme> = { fontSize: 12}
export const sxHistoryValue:SxProps<Theme> = { fontSize: 13,
    border: '#CCC 1px solid', borderRadius: 3, p: 1, textAlign: 'center',
    paddingRight: 1, marginRight: 1, width: 'auto', maxWidth: '100px' }


export interface ILocationLink {
    wnummer: string,
    name: string
}

export interface User {
    userName:  string;
    password?: string;
    confirmPassword?: string;

    fullName: string;
    email: string;
    lastentry?: Date;
    id?: string;
    roleString?: string;
    role?: number;
    assignedHotels?: ILocationLink[];

  }

  export const initialUser: User = {
      fullName: '',
      email: '',
      userName: '',
      password: '',
      roleString: '1',
      role: 1
  };


  export interface ILocationWideResponse {
    location: ILocation,
    roomspace: IFreeRoom,
  }

  export interface IPagedLocationWideResponse {
    locationWithRoomspaces: ILocationWideResponse[],
    totalItems: number,
    currentPage: number
  }
  export const emptyLocationWideResponse: ILocationWideResponse = {
    location: emptyLocation,
    roomspace: emptyRoom
  }
export interface ILocationWide extends ILocation, IFreeSpaceBasic, IFreeRoom {
}



export interface IUserRole {
    roleTitle: string,
    roleValue: number
}

export const UserRoles:IUserRole[] = [
    {
        roleTitle: 'Admin',
        roleValue: 0
    },
    {
        roleTitle: 'Nutzer',
        roleValue: 1
    },
]
